var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7560_45760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.182 27.7C22.7266 27.7 28.032 22.3946 28.032 15.85C28.032 9.30543 22.7266 4 16.182 4C9.63746 4 4.33203 9.30543 4.33203 15.85C4.33203 22.3946 9.63746 27.7 16.182 27.7Z",
    fill: "url(#paint0_linear_7560_45760)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4623 17.7198C23.3646 19.5846 22.5549 21.3407 21.2004 22.6261C19.8458 23.9115 18.0497 24.6281 16.1823 24.6281C14.315 24.6281 12.5188 23.9115 11.1643 22.6261C9.80976 21.3407 9.00012 19.5846 8.90234 17.7198C11.2689 17.0408 13.7204 16.704 16.1823 16.7198C18.6443 16.704 21.0958 17.0408 23.4623 17.7198Z",
    fill: "url(#paint1_linear_7560_45760)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0016 22.8401C19.6704 24.0183 17.9542 24.6687 16.1766 24.6687C14.3989 24.6687 12.6827 24.0183 11.3516 22.8401C12.6856 21.6679 14.4007 21.0215 16.1766 21.0215C17.9524 21.0215 19.6675 21.6679 21.0016 22.8401Z",
    fill: "url(#paint2_linear_7560_45760)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49323 14.9402C9.39372 14.9419 9.29546 14.9179 9.20789 14.8707C9.12033 14.8234 9.0464 14.7543 8.99323 14.6702C8.90445 14.5372 8.87147 14.3746 8.9014 14.2175C8.93133 14.0604 9.02176 13.9213 9.15323 13.8302C10.1792 13.1817 11.2808 12.6612 12.4332 12.2802C11.6432 11.7402 10.5432 11.0502 9.79323 10.6002C9.70227 10.5023 9.64601 10.3771 9.63311 10.2441C9.62021 10.111 9.65138 9.97738 9.72183 9.86376C9.79227 9.75014 9.89809 9.66281 10.023 9.6152C10.1479 9.56758 10.285 9.56232 10.4132 9.60023C11.722 10.3595 12.9812 11.2012 14.1832 12.1202C14.2577 12.1968 14.3108 12.2916 14.3371 12.3952C14.3634 12.4987 14.3621 12.6074 14.3332 12.7102C14.3055 12.8149 14.25 12.9102 14.1725 12.9859C14.0951 13.0616 13.9986 13.1149 13.8932 13.1402C12.4639 13.5237 11.0967 14.1096 9.83323 14.8802C9.72841 14.9337 9.61001 14.9546 9.49323 14.9402Z",
    fill: "#26304E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8612 14.94C22.9902 14.938 23.1152 14.8952 23.2184 14.8178C23.3215 14.7403 23.3974 14.6321 23.4352 14.5087C23.4729 14.3854 23.4706 14.2533 23.4286 14.1313C23.3866 14.0094 23.307 13.9039 23.2012 13.83C22.1773 13.1778 21.0753 12.657 19.9212 12.28C20.7112 11.74 21.8212 11.05 22.5712 10.6C22.7082 10.517 22.807 10.3833 22.8463 10.2281C22.8856 10.0728 22.8622 9.90823 22.7812 9.77002C22.6963 9.63235 22.5609 9.53333 22.404 9.4941C22.247 9.45487 22.081 9.47852 21.9412 9.56002C20.6358 10.3196 19.38 11.1613 18.1812 12.08C18.1106 12.1565 18.0608 12.2498 18.0365 12.351C18.0121 12.4522 18.0141 12.5579 18.0421 12.6582C18.0702 12.7584 18.1234 12.8498 18.1968 12.9236C18.2702 12.9975 18.3612 13.0513 18.4612 13.08C19.8941 13.4626 21.2647 14.0485 22.5312 14.82C22.6262 14.8932 22.7415 14.9351 22.8612 14.94Z",
    fill: "#26304E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7560_45760",
    x1: 16.182,
    y1: 3.9,
    x2: 16.182,
    y2: 27.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDCB56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7560_45760",
    x1: 16.1823,
    y1: 16.7298,
    x2: 16.1823,
    y2: 24.6298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#512512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D4C1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7560_45760",
    x1: 16.1816,
    y1: 21.0001,
    x2: 16.1816,
    y2: 24.6501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6486A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DE274D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD192B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7560_45760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.7,
    height: 23.71,
    fill: "white",
    transform: "translate(4.33203 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiSmile);
export default __webpack_public_path__ + "static/media/emoji_smile.5d98bba5.svg";
export { ForwardRef as ReactComponent };